<button
  mat-button
  [matMenuTriggerFor]="menu"
  *ngIf="!selectedOption"
  class="fast-filter"
  matTooltip="Filtre por {{ name }}"
>
  {{ name }}
  <mat-icon>keyboard_arrow_down</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    *ngFor="let option of options"
    (click)="onSelectionChange(option)"
    class="fast-filter-item"
  >
    {{ option.label }}
  </button>
</mat-menu>

<mat-chip *ngIf="selectedOption" (removed)="clearSelectedOption()">
  <div class="flex items-center gap-2">
    <mat-icon>check</mat-icon>
    {{ selectedOption!.label }}
  </div>
  <mat-icon
    matChipRemove
    matTooltip="Remover {{ name }}: {{ selectedOption!.label }}"
    >cancel</mat-icon
  >
</mat-chip>
